import AnimatedCard, { AnimatedCardProps } from "./AnimatedCard";

export { AnimatedCard, AnimatedCardProps };

export default AnimatedCard;
